import { render, staticRenderFns } from "./summaryTwitch.vue?vue&type=template&id=93cfbcb0&scoped=true&"
import script from "./summaryTwitch.vue?vue&type=script&lang=js&"
export * from "./summaryTwitch.vue?vue&type=script&lang=js&"
import style0 from "./summaryTwitch.vue?vue&type=style&index=0&id=93cfbcb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cfbcb0",
  null
  
)

export default component.exports